import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import appIcon from '../assets/ic_launcher_foreground_hdpi.png';

const SERVER = process.env.REACT_APP_SERVER || '';
const PDF_BASE_PATH = `${SERVER}/api/upload/homeFiles`;

const GUIDES = [
    {
        product: '말랑포켓',
        title: '말랑포켓 사용설명서',
        description: '말랑포켓 사용 방법과 주요 기능을 확인할 수 있는 안내서입니다.',
        fileName: 'mallang_pocket_guide.pdf',
        downloadName: '말랑포켓 사용설명서.pdf',
    },
    {
        product: '말랑북',
        title: '말랑북 사용설명서 (14일)',
        description: '14일 버전 말랑북 사용 방법을 확인할 수 있는 안내서입니다.',
        fileName: 'mallang_book_guide_14days_version.pdf',
        downloadName: '말랑북 사용설명서 (14일).pdf',
    },
    {
        product: '말랑북',
        title: '말랑북 사용설명서 (21일)',
        description: '21일 버전 말랑북 사용 방법을 확인할 수 있는 안내서입니다.',
        fileName: 'mallang_book_guide_21days_version.pdf',
        downloadName: '말랑북 사용설명서 (21일).pdf',
    },
];

function MallangGuidePage() {
    return (
        <Box
            component="main"
            sx={{
                minHeight: '100vh',
                background: '#f7f8fb',
                color: '#17202a',
                py: { xs: 5, md: 8 },
            }}
        >
            <Container maxWidth="md">
                <Stack spacing={{ xs: 4, md: 5 }}>
                    <Stack spacing={1.5} textAlign="center" alignItems="center">
                        <Box
                            sx={{
                                width: 64,
                                height: 64,
                                borderRadius: 2,
                                display: 'grid',
                                placeItems: 'center',
                                backgroundColor: '#e8f1ff',
                                color: '#175ebd',
                            }}
                        >
                            <Box
                                component="img"
                                src={appIcon}
                                alt=""
                                sx={{
                                    width: 64,
                                    height: 64,
                                    objectFit: 'contain',
                                }}
                            />
                        </Box>
                        <Typography
                            component="h1"
                            sx={{
                                fontSize: { xs: 30, sm: 38 },
                                fontWeight: 800,
                                lineHeight: 1.2,
                                letterSpacing: 0,
                            }}
                        >
                            말랑포켓 & 말랑북 사용설명서
                        </Typography>
                        <Typography
                            sx={{
                                color: '#5f6b7a',
                                fontSize: { xs: 16, sm: 18 },
                                lineHeight: 1.7,
                                maxWidth: 570,
                            }}
                        >
                            필요한 사용설명서를 바로 열어보거나 PDF 파일로 다운로드할 수 있습니다.
                        </Typography>
                    </Stack>

                    <Stack spacing={2}>
                        {GUIDES.map((guide) => {
                            const href = `${PDF_BASE_PATH}/${guide.fileName}`;

                            return (
                                <Box
                                    key={guide.fileName}
                                    sx={{
                                        backgroundColor: '#ffffff',
                                        border: '1px solid #e1e7ef',
                                        borderRadius: 2,
                                        p: { xs: 2.25, sm: 3 },
                                        boxShadow: '0 12px 32px rgba(22, 34, 51, 0.07)',
                                    }}
                                >
                                    <Stack
                                        direction={{ xs: 'column', sm: 'row' }}
                                        spacing={2}
                                        alignItems={{ xs: 'stretch', sm: 'center' }}
                                        justifyContent="space-between"
                                    >
                                        <Stack spacing={0.75}>
                                            <Typography
                                                sx={{
                                                    color: '#175ebd',
                                                    fontSize: 14,
                                                    fontWeight: 800,
                                                }}
                                            >
                                                {guide.product}
                                            </Typography>
                                            <Typography
                                                component="h2"
                                                sx={{
                                                    fontSize: { xs: 20, sm: 22 },
                                                    fontWeight: 800,
                                                    lineHeight: 1.35,
                                                    letterSpacing: 0,
                                                }}
                                            >
                                                {guide.title}
                                            </Typography>
                                            <Typography sx={{ color: '#5f6b7a', lineHeight: 1.6 }}>
                                                {guide.description}
                                            </Typography>
                                        </Stack>

                                        <Stack
                                            direction={{ xs: 'column', sm: 'row' }}
                                            spacing={1}
                                            sx={{ minWidth: { sm: 236 } }}
                                        >
                                            <Button
                                                href={href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                variant="outlined"
                                                startIcon={<OpenInNewIcon />}
                                                sx={{
                                                    minHeight: 46,
                                                    borderRadius: 2,
                                                    borderColor: '#c7d0dc',
                                                    color: '#17202a',
                                                    fontWeight: 800,
                                                }}
                                            >
                                                보기
                                            </Button>
                                            <Button
                                                href={href}
                                                download={guide.downloadName}
                                                variant="contained"
                                                startIcon={<DownloadIcon />}
                                                sx={{
                                                    minHeight: 46,
                                                    borderRadius: 2,
                                                    backgroundColor: '#1f2937',
                                                    fontWeight: 800,
                                                    '&:hover': { backgroundColor: '#111827' },
                                                }}
                                            >
                                                다운로드
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Box>
                            );
                        })}
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}

export default MallangGuidePage;
